import { Box, ThemeProvider, Typography, createTheme } from "@mui/material";
import createPalette from "@mui/material/styles/createPalette";
import React from "react";
import { vars } from "../Variables";

const {
  secondaryFont,
  secondaryColor,
  lightYellow
} = vars;

export interface IOnboardingLeftPanel {
  logo?: string;
  icon?: string;
  secondaryText?: string;
  primaryText?: string;
}

declare module '@mui/material/styles' {
  interface Theme { }
  // allow configuration using `createTheme`
  interface ThemeOptions { }
}

const customPalette = createPalette({
  primary: {
    main: lightYellow
  },
  secondary: {
    main: secondaryColor,
  }
})

const theme = createTheme({
  typography: {
    fontFamily: secondaryFont,

    body1: {
      fontSize: '24px',
      lineHeight: '133%',
      fontWeight: 300,
      color: customPalette.secondary.main
    },

    body2: {
      fontSize: '24px',
      lineHeight: '133%',
      fontWeight: 600,
      color: customPalette.secondary.main
    }
  }
});

export const OnboardingLeftPanel: React.FC<IOnboardingLeftPanel> = (props) => {
  const { logo, icon, primaryText, secondaryText } = props;
  const classes = {
    root: {
      background: customPalette.primary.main,
      height: '100vh',
      textAlign: 'center',
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Box
        flexDirection='column'
        alignItems='center'
        display='flex'
        py={10}
        overflow='auto'
        sx={classes.root}
      >
        <img src={logo} alt="logo" />

        <Box mt='auto' pt={5}>
          <img src={icon} alt="steps-icon" />
          <Box mt={3.5}>
            <Typography variant="body1">{primaryText}</Typography>
            <Typography variant="body2">{secondaryText}</Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  )
};